import { useId } from "react";

export const LegendaryBorder = ({ beamRef }) => {
  const gradient = useId().replace(/:/g, "");
  return (
    <>
      <span className="legendary-frame" aria-hidden="true" data-testid="roadmap-10m-gold-frame"
        style={{ borderImageSource: "url(/assets/artwork/legendary/gold-bezel.webp)" }} />
      <svg className="legendary-border" aria-hidden="true" focusable="false" data-testid="roadmap-10m-border">
        <defs>
          <linearGradient id={gradient} x1="0" y1="1" x2="1" y2="0">
            <stop offset="0%" stopColor="#2fff85" />
            <stop offset="55%" stopColor="#b9ffcd" />
            <stop offset="100%" stopColor="#efd38d" />
          </linearGradient>
        </defs>
        <rect className="legendary-border__rail" x="2" y="2" rx="8" />
        <g ref={beamRef} stroke={`url(#${gradient})`} data-testid="roadmap-10m-border-beam">
          <rect className="legendary-border__beam legendary-border__beam--tail" x="2" y="2" rx="8" pathLength="100" />
          <rect className="legendary-border__beam legendary-border__beam--tip" x="2" y="2" rx="8" pathLength="100" />
        </g>
      </svg>
    </>
  );
};

export const LegendaryCore = () => (
  <div className="legendary-core" aria-hidden="true" data-testid="roadmap-10m-energy-core">
    {[0, 1, 2].map((i) => <span key={i} className="legendary-core__wave" style={{ "--wave": i }} />)}
    {[[-82, -22], [75, 26], [-58, 36], [44, -39], [-90, 13], [88, -32]].map(([x, y], i) => (
      <i key={i} className={`legendary-core__particle ${i > 3 ? "legendary-core__particle--extra" : ""}`}
        style={{ "--px": `${x}px`, "--py": `${y}px`, "--particle": i }} />
    ))}
  </div>
);

export const LegendaryFeed = () => (
  <span className="legendary-feed" aria-hidden="true" data-testid="roadmap-10m-energy-feed">
    <span className="legendary-feed__pulse" />
  </span>
);